import { applyMiddleware, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import logoutEnhancer from './enhancers/logout';
import createRootReducer from './reducers';
import { watchSagas } from './watchSagas';
import { config } from '../config/env';

export const history = createBrowserHistory();

const initializeStore = (preloadedState: any) => {
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [sagaMiddleware, routerMiddleware(history)];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers = [middlewareEnhancer, logoutEnhancer];

  const store = configureStore({
    reducer: createRootReducer(history),
    preloadedState,
    enhancers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: false,
        serializableCheck: !config.isProduction,
        immutableCheck: !config.isProduction,
      }),
    devTools: !config.isProduction,
  });

  sagaMiddleware.run(watchSagas);

  return { store };
};

export default initializeStore;
